"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneNumberComponent = void 0;
const react_1 = __importStar(require("react"));
require("./index.scss");
const InputText_1 = __importDefault(require("@Components/Fields/InputText"));
const Dropdown_1 = __importDefault(require("@Components/Selectors/Dropdown"));
const mobx_react_1 = require("mobx-react");
const forms_constants_1 = require("@Const/forms-constants");
const contexts_1 = require("@App/contexts");
exports.PhoneNumberComponent = (0, mobx_react_1.observer)((props) => {
    const { libStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const countryPhoneOptions = libStore.phoneCountryCodes;
    const getValue = (value, id) => {
        switch (id) {
            case forms_constants_1.PHONE_NUMBER_FORM.phoneCountryCode.id:
                props.onChange(value, forms_constants_1.PHONE_NUMBER_FORM.phoneCountryCode.id);
                break;
            case forms_constants_1.PHONE_NUMBER_FORM.phoneAreaCode.id:
                props.onChange(value, forms_constants_1.PHONE_NUMBER_FORM.phoneAreaCode.id);
                break;
            case forms_constants_1.PHONE_NUMBER_FORM.phoneNumber.id:
                props.onChange(value, forms_constants_1.PHONE_NUMBER_FORM.phoneNumber.id);
                break;
            default:
                break;
        }
    };
    return (react_1.default.createElement("div", { className: "phone-number-component" },
        react_1.default.createElement("p", { className: 'small main-label' }, "Phone Number"),
        react_1.default.createElement("div", { className: 'inputs-block' },
            react_1.default.createElement("div", { className: "country" },
                react_1.default.createElement(Dropdown_1.default, { options: countryPhoneOptions, id: forms_constants_1.PHONE_NUMBER_FORM.phoneCountryCode.id, selectedValue: countryPhoneOptions.find((option) => Number(option.value) === props.phoneCountryCode), placeholder: 'Country', mainColor: true, isPhoneCodeType: true, isBorder: true, onSelect: (data) => getValue(Number(data.value), forms_constants_1.PHONE_NUMBER_FORM.phoneCountryCode.id), isSearchable: true, isNumberType: true, errorMessage: props.phoneCountryCodeError, assistiveText: props.phoneCountryCodeRequired ? 'Country Required' : 'Country' })),
            react_1.default.createElement("div", { className: "area" },
                react_1.default.createElement(InputText_1.default, { mainColor: true, id: forms_constants_1.PHONE_NUMBER_FORM.phoneAreaCode.id, label: '', assistiveText: props.phoneAreaCodeRequired ? 'Area Required' : 'Area', onChange: getValue, value: props.phoneAreaCode, errorMessage: props.phoneAreaCodeError })),
            react_1.default.createElement("div", { className: "number" },
                react_1.default.createElement(InputText_1.default, { mainColor: true, id: forms_constants_1.PHONE_NUMBER_FORM.phoneNumber.id, label: '', onChange: getValue, value: props.phoneNumber, errorMessage: props.phoneNumberError, assistiveText: props.phoneNumberRequired ? 'Required Number' : 'Number' })))));
});
